import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
// Copyright 2017-2022 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { stringCamelCase } from '@polkadot/util';

function convert(fn) {
  return function (_ref) {
    var name = _ref.name;
    return fn(name);
  };
}

export var objectNameToCamel = convert(stringCamelCase);
export var objectNameToString = convert(function (n) {
  return n.toString();
});